declare const window: any;

export interface IMetaMaskUtils {
  provider: any;
  account: string | null;
  isAccountConnected: boolean;
  chainId: number | null;
  isMetaMaskInstalled(): boolean;
  isConnected(): boolean;
  getProvider(): any;
  requestAccount(): Promise<string | undefined>;
  getAccounts(): Promise<string[]>;
  getChainId(): Promise<number | null>;
  setAccount(account: string | null): void;
}

export default class MetaMaskUtils implements IMetaMaskUtils {
  provider: any;
  account: any;
  isAccountConnected: boolean;
  chainId: number | null;

  constructor() {
    this.provider = window.ethereum;
    this.account = null;
    this.isAccountConnected = false;
    this.chainId = null;
  }

  setAccount(account: string | null) {
    this.account = account;
  }

  isMetaMaskInstalled(): boolean {
    return Boolean(this.provider && this.provider.isMetaMask);
  }

  isConnected(): boolean {
    if (!this.isMetaMaskInstalled()) return false;
    return this.provider && this.provider.isConnected() && this.isAccountConnected;
  }

  getProvider(): any {
    return this.provider;
  }

  async requestAccount(): Promise<string | undefined> {
    if (!this.isMetaMaskInstalled()) return Promise.reject('MetaMask not installed');

    const [account] = await this.provider.request({ method: 'eth_requestAccounts' });
    if (!account) return Promise.reject('Can not get address');

    this.setAccount(account);
    this.isAccountConnected = true;
    return account;
  }

  async getAccounts(): Promise<string[]> {
    const accounts = await this.provider.request({ method: 'eth_accounts' });
    return accounts;
  }

  async getChainId(): Promise<number | null> {
    if (!this.provider) return Promise.resolve(this.chainId);

    const chainId = await this.provider.request({ method: 'eth_chainId' });
    this.chainId = Number(chainId);
    return this.chainId;
  }
}
